package com.bikompanion.ui.strings

val IdBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Coba lagi"
    override val actionClose = "Tutup"
    override val actionSubmit = "Kirim"
    override val detailsLabel = "Detail"
    override val detailsShow = "Tampilkan detail"
    override val detailsHide = "Sembunyikan detail"
    override val actionGetDirections = "Petunjuk arah"
    override val actionShareStation = "Bagikan stasiun"
    override val linkCopied = "Tautan disalin"
    override val locateShow = "Tampilkan lokasi saya"
    override val locateFollowHeading = "Ikuti arah saya"
    override val locateStopFollowing = "Berhenti mengikuti saya"
    override val settingsTitle = "Setelan"
    override val actionBack = "Kembali"
    override val settingsAppearance = "Tampilan"
    override val settingsLanguage = "Bahasa"
    override val languageSystem = "Default sistem"
    override val themeSystem = "Sistem"
    override val themeLight = "Terang"
    override val themeDark = "Gelap"
    override val settingsNotifications = "Notifikasi"
    override val stationAlerts = "Peringatan stasiun"
    override val notificationsOn = "Aktif: Anda akan diberi tahu saat stasiun yang dipantau punya sepeda"
    override val notificationsOff = "Nonaktif: stasiun yang dipantau tidak dapat memberi tahu Anda"
    override val notificationsBlocked = "Diblokir: izinkan notifikasi di setelan situs browser Anda"
    override val actionManage = "Kelola"
    override val actionTurnOn = "Aktifkan"
    override val settingsSupport = "Dukungan"
    override val sendFeedback = "Kirim masukan"
    override val sendFeedbackDescription = "Beri tahu kami tentang masalah atau data stasiun yang salah"
    override val shareApp = "Bagikan aplikasi"
    override val settingsAbout = "Tentang"
    override val aboutApp = "Tentang Bikompanion"
    override val aboutDevelopedBy = "Dikembangkan oleh Tiago Araujo"
    override val aboutDataSources = "Sumber data"
    override val sourceCityBikesDescription = "Jaringan sepeda bersama di seluruh dunia"
    override val sourceGbfsTitle = "Feed GBFS operator"
    override val sourceGbfsDescription = "Data stasiun langsung dari operator sepeda bersama"
    override val sourceOsmTitle = "Kontributor OpenStreetMap"
    override val sourceOsmDescription = "Parkir sepeda dan data peta"
    override val sourceCartoDescription = "Tile peta"
    override val aboutLegal = "Legal"
    override val licensesTitle = "Lisensi sumber terbuka"
    override val privacyPolicy = "Kebijakan privasi"
    override val deleteRatings = "Hapus penilaian saya"
    override val deleteRatingsDescription = "Mengirim ID anonim Anda lewat email agar kami bisa menghapusnya"
    override val licensesLoadFailed = "Tidak dapat memuat daftar lisensi"
    override val aboutVersion = { version: String -> "Versi $version" }
    override val issueFlatTire = "Ban kempes"
    override val issueFrontBrake = "Rem depan tidak berfungsi"
    override val issueRearBrake = "Rem belakang tidak berfungsi"
    override val issueChain = "Rantai selip"
    override val issueGears = "Gigi tidak bisa pindah"
    override val issueSeat = "Sadel rusak atau hilang"
    override val issueLights = "Lampu tidak berfungsi"
    override val issueLockOrBasket = "Kunci atau keranjang rusak"
    override val issueFrame = "Rangka rusak"
    override val issueMotor = "Motor listrik tidak berfungsi"
    override val issueBattery = "Baterai tidak mengisi"
    override val issueOther = "Lainnya"
    override val networksLoadFailed = "Tidak dapat memuat jaringan sepeda. Periksa koneksi Anda."
    override val parkingLoadFailed = "Tidak dapat memuat parkir sepeda"
    override val parkingLoading = "Mencari parkir sepeda…"
    override val stationsLoading = "Memuat stasiun sepeda…"
    override val noNetworkHereTitle = "Tidak ada sepeda sewa di sini"
    override val noNetworkHereHint = "Perkecil peta untuk menemukan jaringan terdekat"
    override val installTitle = "Instal Bikompanion"
    override val installHintIos = "Ketuk Bagikan, lalu Tambahkan ke Layar Utama."
    override val installHintAndroid = "Dapatkan aplikasinya di Google Play."
    override val actionInstall = "Instal"
    override val parkingTypeStands = "Rak sepeda"
    override val parkingTypeShed = "Gudang sepeda"
    override val parkingTypeLockers = "Loker sepeda"
    override val parkingTypeBuilding = "Gedung sepeda"
    override val parkingTypeOther = "Parkir sepeda"
    override val fieldAddress = "Alamat"
    override val fieldCovered = "Beratap"
    override val fieldYes = "Ya"
    override val fieldNo = "Tidak"
    override val fieldId = "ID"
    override val fieldStationId = "ID stasiun"
    override val fieldCoordinates = "Koordinat"
    override val fieldCapacity = "Kapasitas"
    override val fieldNetwork = "Jaringan"
    override val fieldName = "Nama"
    override val fieldCity = "Kota"
    override val fieldCountry = "Negara"
    override val fieldCompany = "Perusahaan"
    override val fieldLicense = "Lisensi"
    override val fieldLicenseUrl = "URL lisensi"
    override val availabilityBikes = "Sepeda"
    override val availabilityElectric = "Listrik"
    override val availabilityEmpty = "Kosong"
    override val bicingNextPickup = { p0: String -> "Pengambilan Bicing berikutnya dalam $p0" }
    override val rateTitle = "Periksa atau nilai sepeda"
    override val rateFindingNetworks = "Mencari jaringan sepeda di sekitar Anda…"
    override val rateWhatsWrong = "Apa masalahnya?"
    override val rateBikeNumber = "Nomor sepeda"
    override val rateElectricBike = "Sepeda listrik"
    override val rateVoteBad = "Buruk"
    override val rateVoteGood = "Bagus"
    override val rateWhichNetwork = "Sepeda ini dari jaringan mana?"
    override val refreshRateLimited = "Batas permintaan tercapai — mencoba lagi otomatis"
    override val refreshFailed = "Tidak dapat memperbarui"
    override val refreshNextUpdate = { p0: Int -> "Pembaruan berikutnya dalam $p0 dtk" }
    override val refreshUpdating = "Memperbarui…"
    override val dataNone = "Belum ada data"
    override val dataAgeJustNow = "Menampilkan data barusan"
    override val dataAgeMinutes = { p0: Int -> "Menampilkan data $p0 mnt lalu" }
    override val dataAgeHours = { p0: Int -> "Menampilkan data $p0 jam lalu" }
    override val dataAgeDays = { p0: Int -> "Menampilkan data $p0 hari lalu" }
    override val actionOpenOperator = { p0: String -> "Buka $p0" }
    override val watchNormal = "Pantau sepeda biasa"
    override val watchElectric = "Pantau sepeda listrik"
    override val watchInstallNormal = "Instal aplikasi untuk memantau sepeda biasa"
    override val watchInstallElectric = "Instal aplikasi untuk memantau sepeda listrik"
    override val watchStopNormal = "Berhenti memantau sepeda biasa"
    override val watchStopElectric = "Berhenti memantau sepeda listrik"
    override val actionCheckRateBike = "Periksa / Nilai sepeda"
    override val layerStations = "Stasiun"
    override val layerParking = "Parkir sepeda"
    override val mapLabelBikes = { p0: Int -> "$p0 sepeda" }
    override val mapLabelEbikes = { p0: Int -> "$p0 listrik" }
    override val mapLabelFree = { p0: Int -> "$p0 kosong" }
    override val scoreHeadline = { p0: String, p1: String -> "Sepeda $p0 · $p1" }
    override val scoreNoRatings = "Belum ada penilaian — jadilah yang pertama."
    override val scoreLooksGood = "Terlihat bagus."
    override val scoreHasProblems = "Pengendara lain mengalami masalah dengan sepeda ini."
    override val scoreMixed = "Ulasan beragam."
    override val ratingNetworkRequired = "Pilih dulu jaringan sepeda ini."
    override val ratingThanks = { p0: String -> "Terima kasih telah menilai sepeda $p0!" }
    override val ratingCooldown = { p0: Int -> "Anda baru saja menilai sepeda ini. Coba lagi dalam $p0 mnt." }
    override val ratingQueued = "Disimpan — akan kami kirim saat Anda kembali online."
    override val ratingInvalidBike = "Nomor sepeda itu tidak valid untuk jaringan ini."
    override val ratingRejected = "Tidak dapat menyimpan penilaian itu. Coba lagi nanti."
    override val notificationFoundTitle = "Sepeda tersedia"
    override val notificationFoundNormal = { p0: String -> "Sepeda biasa tersedia di $p0" }
    override val notificationFoundElectric = { p0: String -> "Sepeda listrik tersedia di $p0" }
    override val notificationExpiredTitle = "Pemantauan stasiun berakhir"
    override val notificationExpiredNormal = { p0: String -> "Pemantauan sepeda biasa di $p0 dihentikan setelah 30 menit" }
    override val notificationExpiredElectric = { p0: String -> "Pemantauan sepeda listrik di $p0 dihentikan setelah 30 menit" }
    override val channelWatchAlertsName = "Peringatan pemantauan stasiun"
    override val channelWatchAlertsDescription = "Ketersediaan sepeda dan pembaruan pemantauan stasiun"
    override val channelBackgroundWatchName = "Pemantauan stasiun di latar belakang"
    override val notificationWatchingTitle = "Memantau stasiun sepeda"
    override val notificationWatchingText = "Memantau stasiun pilihan di latar belakang"
    override val scoreFewRatings = { count: Int -> "Baru $count penilaian." }
    override val scorePositiveRides = { percent: Int, count: Int -> "$percent% positif dari $count perjalanan terakhir" }
}
